/**
 *@description
 @author hasna noufal 
 * This Component used to Record events 
 * Start event
 * End event 
 * Revert Event
 */

import { Table, message, Skeleton, Typography } from 'antd';

import React, { useEffect, useState, useContext, useRef } from 'react';

import './event-list.scss';

import VisitInfo from '../emr/components/visit-info/visit-info';

import { Location, GlobalContext, useTranslation, TableComponent, Button, Card } from 'soxo-bootstrap-core';

import { EventTransactions } from '../../models';

import moment from 'moment';

const { Text } = Typography;

export default function EventList({ isCardView, params, currentRoomPointer, ...props }) {
    // Current page number for pagination
const [page, setPage] = useState(1);

// Number of items to show per page
const [limit, setLimit] = useState(10);

// Tracks loading state (e.g., when fetching data)
const [loading, setLoading] = useState(false);

// Extract query parameters from the URL (e.g., ?id=123)
var urlParams = Location.search();

// Stores the fetched details (like list of items, events, etc.)
const [details, setDetails] = useState([]);

// Timer state — true if timer is running
const [timer, setTimer] = useState(false);

// Get current user info from global context
const { user } = useContext(GlobalContext);

// Tracks the currently selected or active event (null by default)
const [activeEvent, setActiveEvent] = useState(null);

// Setup for i18n (internationalization)
const { t, i18n } = useTranslation();

// Ref to store the interval ID for the timer (used for clearing it)
const intervalRef = useRef(null);

// How many seconds have passed since timer started
const [secondsPassed, setSecondsPassed] = useState(0);


    // const [timerEventId, setTimerEventId] = useState(null);
    // To Translate to another language

    let otherDetails;

    useEffect(() => {
        // getEventTimeline(urlParams);
        if (isCardView) {
            getEventTimeline(params);
        } else {
            getEventTimeline(urlParams);
        }
    }, []);

    useEffect(() => {
        if (!loading && details.length > 0) {
            const currentEvent = details.find((event) => event.status === 'IN' && event.room_pointer === currentRoomPointer);
            if (currentEvent && currentEvent.start_time && !currentEvent.event_end_time) {
                const now = moment();
                const startedAt = moment(currentEvent.start_time, 'HH:mm:ss');

                // Adjust for next day if needed
                if (now.isBefore(startedAt)) {
                    now.add(1, 'day');
                }

                const diffSeconds = now.diff(startedAt, 'seconds');
                setSecondsPassed(diffSeconds);
                setTimer(true);
                startTimer(diffSeconds);
            }
        }
    }, [details, loading]);
        /**
     * Starts a timer that increments `secondsPassed` every second.
     * If already running, it resets and starts from the provided initial seconds.
     *
     * @param {number} initialSeconds - Optional. The number of seconds to start the timer from (default is 0).
     */

    const startTimer = (initialSeconds = 0) => {
        clearInterval(intervalRef.current);
        setSecondsPassed(initialSeconds);
        // setTimerEventId(eventId);
        intervalRef.current = setInterval(() => {
            setSecondsPassed((prev) => prev + 1);
        }, 1000);
    };

    /**
 * Stops the running timer by clearing the interval.
 * This pauses the timer and prevents `secondsPassed` from increasing.
 */

    const stopTimer = () => {
        clearInterval(intervalRef.current);
    };

    /**
     * Function to format a number of seconds into a time string
     * @param {*} s
     * @returns
     */
    const formatTime = (s) => {
        // Convert seconds to milliseconds, create a UTC moment object, and format it
        return moment.utc(s * 1000).format('HH : mm : ss');
    };

    /**
     * // Function to get the difference between two time strings  in seconds
     * @param {*} start
     * @param {*} end
     * @returns
     */
    function getTimeDifferenceInSeconds(start, end) {
        // Parse the start time string into a moment object
        const startTime = moment.tz(start, 'HH:mm:ss', process.env.REACT_APP_TIMEZONE);
        let endTime = moment.tz(end, 'HH:mm:ss', process.env.REACT_APP_TIMEZONE);

        // Handle the case where the end time is before the start time (next day scenario)
        if (endTime.isBefore(startTime)) {
            endTime.add(1, 'day');
        }

        // Return the time difference in seconds
        return endTime.diff(startTime, 'seconds', true);
    }

    /**
     *get all event list
     * @param {*} urlParams
     */
    async function getEventTimeline(value) {

        setLoading(true);
        let disableEndButton = false;
        let disableStartButton = false;
        // get other_details from user table .
        // allow_revert , room_pointer are saved in other details
        // these fields are used for making event list user specific
        if (user.other_details) {
            otherDetails = JSON.parse(user.other_details);
        }
        let response = await EventTransactions.getEventsTimeline(value);
        setLoading(false);
        let data = response.data.map((element) => {
            /**room_pointer is saved in core users . Its used to show event list in user specific*/
            if (otherDetails && otherDetails.room_pointer) {
                // The room pointers are not equal . then start Button and end button want to disable for users
                if (element.room_pointer !== otherDetails.room_pointer) {
                    disableStartButton = true;
                    disableEndButton = true;
                    element = {
                        ...element,
                        disableStartButton: disableStartButton,
                        disableEndButton: disableEndButton,
                    };
                }
            }

            /** set disable for the end button for 'Room Out' case */
            if (element.status === 'OUT') {
                disableEndButton = true;
                element = {
                    ...element,
                    disableEndButton: disableEndButton,
                };
                return element;
            } else {
                return element;
            }
        });
        // set values to the state
        setDetails(data);
        // });
        return response.data;
    }

    /**
     * Revert the events .Revert Button is user specific
     * @param {*} record
     */
    function eventRevertOption(record) {
        let data = {
            id: record.id,
            refrence_id: urlParams.opb_id,
        };
        EventTransactions.eventRevert(data).then((result) => {
            if (result.success) {
                message.success(result.message);
                // setBtnLoading(false);
                getEventTimeline(urlParams);
            } else {
                message.error(result.message);
                getEventTimeline(urlParams);
            }
        });
    }
    /**
     * Onclick of start button
     * @param {*} record
     */
    function onClick(record) {
        setTimer(true);
        let buttonLoading = false;
        /** filtering data . Check there is any ongoing event is present  */

        let filter = details.filter((values) => values.status === 'IN');
        /** if there iss any on going events take place set alert to end the event  */
        // if (filter[0]) {
        //     message.error('Please close the On Going Event');
        // } else {
        /** if the there is no on going events. Then we can start next event  */
        onsetEvent({ ...record });
        // }
        /** set button loaing for each record  */
        let data = details.map((ele) => {
            /** set a varible to handle loading of button  */
            if (record.location_id === ele.location_id && filter && filter.length === 0) {
                buttonLoading = true;
                return (ele = {
                    ...ele,
                    buttonLoading: buttonLoading,
                });
            } else {
                buttonLoading = false;
                return (ele = {
                    ...ele,
                    buttonLoading: buttonLoading,
                });
            }
        });
        setDetails(data);
    }
    /**
     * submit functionality
     * @param {*} event
     * @param {*} record
     */
    async function onsetEvent(record) {
        if (isCardView) {
            setActiveEvent(null); // reset timer in table view
        }
        /** FormBody */
        let formBody = {
            //actually location_id is passed from the  frond end as event_id.
            event_id: record.location_id,
            refrence_id: urlParams.opb_id,
            // room status true in room in case . room status is false in room out case
            // room_status: record.room_status,
        };
        /** create/update eventTran */
        EventTransactions.createEvent(formBody).then(async (result) => {
            if (result.success) {
                message.success(result.message);
                // setBtnLoading(false);
                let response = await getEventTimeline(urlParams);
                let data = response.find((ele) => ele.room_pointer === currentRoomPointer);
                if (data.status === 'IN') {
                    startTimer();
                } else {
                    stopTimer();
                }
            } else {
                message.error(result.message);
                getEventTimeline(urlParams);
            }
        });
    }

    /**
     *Columns
     */
    const columns = [
        {
            title: '#',
            dataIndex: 'index',
            render: (value, item, index) => {
                return (page - 1) * limit + index + 1;
            },
        },

        {
            title: t('Event'),
            dataIndex: 'location',
            key: 'location',
        },
        {
            title: t('Status'),
            dataIndex: 'status',
            key: 'status',
        },
        {
            title: t('Start Time'),
            dataIndex: 'start_time',
            key: 'start_time',
        },
        {
            title: t('End Time'),
            dataIndex: 'end_time',
            key: 'end_time',
        },
        {
            title: t('Action'),
            fixed: 'right',

            render: (record) => {
                if (record.start_time) {
                    return (
                        <>
                            <div className="events-end">
                                <Button
                                    loading={record.buttonLoading}
                                    disabled={record.disableEndButton}
                                    onClick={() => {
                                        onsetEvent({ ...record });
                                    }}
                                >
                                    {t('End')}
                                </Button>
                                {/**allow_revert  is used to enable the Revert Button
                                 * And also want to check the event is End  */}
                                {record.disableEndButton && otherDetails && otherDetails.allow_revert ? (
                                    <Button
                                        onClick={() => {
                                            eventRevertOption(record);
                                        }}
                                    >
                                        {t('Revert')}
                                    </Button>
                                ) : null}
                            </div>
                        </>
                    );
                } else {
                    return (
                        <Button
                            disabled={record.disableStartButton}
                            loading={record.buttonLoading}
                            onClick={() => {
                                onClick(record);
                            }}
                        >
                            {t('Start')}
                        </Button>
                    );
                }
            },
        },
    ];
    return (
        <>
            {!isCardView ? (
                <Card className="event-details">
                    <div className="right">
                        {/** Guest information Loading  */}
                        <div className="event-list">
                            <VisitInfo
                                mode={props.mode}
                                reference_number={urlParams.opno}
                                disableFields={props.disableFields}
                                onReceiveGuestDetails={() => { }}
                            />
                        </div>

                        <div>
                            {loading ? (
                                <>
                                    <Skeleton></Skeleton>
                                </>
                            ) : (
                                <>
                                    {/** Table content  */}
                                    <TableComponent scroll={{ x: true }} dataSource={details} columns={columns} pagination={false} />
                                </>
                            )}
                        </div>
                    </div>
                </Card>
            ) : (
                <>
                    {details
                        // Filter for the currently active room
                        .filter((room) => room.room_pointer === currentRoomPointer)
                        .map((room) => {
                            let currentRoom = details.filter((ele) => ele.status == 'IN')
                            let momentTime = moment().format('hh:mm:ss A');
                            let label = 'Not Started Yet';
                            let color = 'lightyellow';
                            let text = ' Starts In';
                            let seconds = secondsPassed;
                            let borderColor = 'yellow';
                            // If the event has started and is ongoing
                            if (room.start_time && room.status == 'IN') {
                                label = 'On Going';
                                color = '#d3e2d3';
                                text = 'Time Passed:';
                                borderColor = 'green';
                                // If the event has ended
                            } else if (room.end_time && room.status != 'IN') {
                                label = 'Ended';
                                color = '#e9e7ee';
                                text = 'Total Time:';
                                borderColor = '#6c48f2';
                            }
                            // Calculate the actual seconds difference based on status
                            if (room.status) {
                                if (room.status === 'IN') {
                                    // console.log("startTime",room.event_start_time, momentTime)
                                    // Event is ongoing, calculate duration until now
                                    seconds = getTimeDifferenceInSeconds(room.event_start_time, momentTime);
                                } else {
                                    // Event has ended, calculate full event duration
                                    seconds = getTimeDifferenceInSeconds(room.event_start_time, room.event_end_time);
                                }
                            }
                            // Render card UI
                            return (
                                <div
                                    className="card-section card consultation-card"
                                    key={room.sub_event_id}
                                    bordered
                                    style={{
                                        backgroundColor: color,
                                        borderColor: borderColor,
                                    }}
                                >
                                    {/* Time Range */}
                                    {room.status ? (
                                        // <Text className="bold-text dark-color line-spacing">
                                        //     {room.start_time || '--'} - {room.end_time || '--'}
                                        // </Text>
                                        <div className="flex-space-between">
                                            <div>{`${room.start_time || '--'} - ${room.end_time || '--'}`}</div>
                                            {/* <Text className="bold-text dark-color">Consultation Ongoing.</Text> */}
                                        </div>
                                    ) : null}

                                    {/* Time Counter and Buttons */}
                                    <div className="flex-space-between">
                                        <Text>{text}</Text>
                                        <Text className="bold-text dark-color line-spacing">{formatTime(seconds)}</Text>
                                        <div>
                                            {room.status === 'IN' ? (
                                                <>
                                                    <Button
                                                        className="timer-button"
                                                        type="primary"
                                                        size="small"
                                                        danger
                                                        disabled={room.disableEndButton}
                                                        // style={
                                                        //     {
                                                        //         width: '53px',
                                                        //         height: '20px',
                                                        //         fontSize: '10px',
                                                        //         marginLeft: '7px',
                                                        //         marginBottom: '10px'
                                                        //     }
                                                        // }
                                                        onClick={() => {
                                                            onsetEvent(room);
                                                            stopTimer();
                                                        }}
                                                    >
                                                        End
                                                    </Button>
                                                </>
                                            ) : null}
                                            {!room.status ? (
                                                <>
                                                    <Button
                                                        className="timer-button"
                                                        // style={
                                                        //     {
                                                        //         width: '53px',
                                                        //         height: '20px',
                                                        //         fontSize: '10px',
                                                        //         marginLeft: '7px',
                                                        //         marginBottom: '10px'

                                                        //     }
                                                        // }
                                                        type="primary"
                                                        size="small"
                                                        danger
                                                        onClick={() => {
                                                            onClick(room);
                                                        }}
                                                    >
                                                        Start
                                                    </Button>
                                                </>
                                            ) : null}
                                        </div>
                                    </div>

                                    {/* <div className="timer-button-section">
                                        <>
                                            <Text className="bold-text dark-color line-spacing">
                                                {text + ``} {formatTime(seconds)}
                                                {text + ``} {formatTime(secondsPassed)}
                                            </Text>
                                        </>
                                    </div> */}

                                    {/* Location and Status Label */}
                                    <Text strong>
                                        {room.location} {label}.
                                    </Text>
                                    {currentRoom[0] && !room.status ?
                                        <Text>
                                            {/* {room.location} {label}. */}
                                            {currentRoom[0].location} - Ongoing Now
                                        </Text> : null}
                                    {/* )} */}
                                </div>
                            );
                        })}
                </>
            )}
        </>
    );
}
